
<div class="page-loader">
    <div class="page-loader__throbber">
        <spinner />
    </div>
</div>
